import { action, makeObservable, observable, runInAction } from 'mobx'

import { SaveUploadLogConfigurationDocument } from '~/client/graph/operations/generated/UploadLogConfiguration.generated'
import { IUploadLogConfiguration } from '~/client/graph/types.generated'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import Guard from '~/client/src/shared/utils/Guard'

import {
  GET_UPLOAD_LOG_CONFIGURATION,
  LISTEN_TO_UPLOAD_LOG_CONFIGURATION,
  SAVE_UPLOAD_LOG_CONFIGURATION,
} from '../EventStore/eventConstants'
import GraphExecutorStore from './GraphExecutor.store'

export default class UploadLogConfigurationStore {
  @observable public configuration: IUploadLogConfiguration = null
  @observable public isDataReceived: boolean = false

  public constructor(
    private readonly eventsStore: EventsStore,
    private readonly graphExecutorStore: GraphExecutorStore,
  ) {
    makeObservable(this)
    this.resetToDefault()
    Guard.requireAll({
      eventsStore,
    })
  }

  @action.bound
  public resetToDefault() {
    this.configuration = {
      maps: [],
      projectId: this.eventsStore.appState.activeProject.id,
    }
  }

  @action.bound
  public async getUploadLogConfiguration() {
    const { id: projectId } = this.eventsStore.appState.activeProject

    this.eventsStore.dispatch(GET_UPLOAD_LOG_CONFIGURATION, {
      projectId,
    })
  }

  @action.bound
  public async saveUploadLogConfiguration(
    uploadLogConfiguration: IUploadLogConfiguration,
  ) {
    this.eventsStore.appState.loading.set(SAVE_UPLOAD_LOG_CONFIGURATION, true)

    Object.assign(this.configuration, uploadLogConfiguration)

    await this.graphExecutorStore.mutate(SaveUploadLogConfigurationDocument, {
      uploadLogConfiguration: this.configuration,
    })

    runInAction(() => {
      this.eventsStore.appState.loading.set(
        SAVE_UPLOAD_LOG_CONFIGURATION,
        false,
      )
    })
  }

  @action.bound
  public async listenToUploadLogConfiguration() {
    const { id: projectId } = this.eventsStore.appState.activeProject

    this.eventsStore.dispatch(LISTEN_TO_UPLOAD_LOG_CONFIGURATION, {
      projectId,
    })
  }

  public get isLoading(): boolean {
    return this.eventsStore.appState.loading.get(GET_UPLOAD_LOG_CONFIGURATION)
  }

  @action.bound
  public receiveUploadLogConfiguration(
    uploadLogConfiguration: IUploadLogConfiguration,
  ) {
    this.configuration = uploadLogConfiguration
    this.isDataReceived = true
  }
}
